// components/asset-landing/Hero.tsx
"use client";
import { AssetLandingContent } from "@/lib/assets/types";
import Button from "@/components/asset-landing/Button";
import { useEffect, useState } from "react";

export default function Hero({ content }: { content: AssetLandingContent }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const TICKER_ITEMS = [
    // { value: "₦900.2M+", label: "Total volume converted" },
    { value: "5+", label: "Crypto Networks" },
    { value: "<30s", label: "Settlement Time" },
    { value: "24/7", label: "Support" },
    { value: "100%", label: "Secure" },
    { value: "0", label: "Set up Fees" },
  ];

  const { hero, heroImage, accentColor } = content;

  const renderHeadline = () => {
    const words = hero.headline.split(" ");
    return words.map((word, i) => {
      const isHighlighted = hero.highlightedWords.some((h) =>
        word.includes(h.replace("!", ""))
      );
      return (
        <span
          key={i}
          className={isHighlighted ? "text-[var(--accent-color)]" : undefined}
        >
          {word}{" "}
        </span>
      );
    });
  };

  return (
    <>
      <section
        style={
          {
            backgroundImage: `url('${heroImage}')`,
            "--accent-color": accentColor,
          } as React.CSSProperties
        }
        className={`relative w-full bg-cover bg-left md:bg-center bg-no-repeat min-h-[70vh] md:min-h-[80vh] ${
          isScrolled ? "pt-16 sm:pt-28 md:pt-36" : "pt-0"
        } pb-16 sm:pb-24 md:pb-36 flex items-center flex-col justify-center font-inter px-4`}
      >
        <h1 className="text-4xl md:text-5xl lg:text-[64px] text-[#010721] font-semibold leading-tight sm:leading-[1.15] lg:leading-[74px] tracking-[-0.5px] text-center max-w-[320px] sm:max-w-[480px] lg:max-w-[600px] font-onest">
          {renderHeadline()}
        </h1>
        <p className="mt-4 text-base sm:text-lg lg:text-xl tracking-[-0.45px] text-[#79747E] max-w-[320px] sm:max-w-[480px] lg:max-w-[600px] text-center">
          {hero.subtext}
        </p>
        <div className="mt-6 sm:mt-8">
          <Button {...hero.cta} />
        </div>
      </section>

      <div className="w-full bg-[#E5F3F9] overflow-hidden h-[90px] sm:h-[100px] md:h-[120px] flex items-center font-inter">
        <div
          className="flex items-center"
          style={{ animation: "heroTicker 18s linear infinite" }}
        >
          {[0, 1, 2, 3].map((setIndex) => (
            <div key={setIndex} className="flex items-center flex-shrink-0">
              {TICKER_ITEMS.map((item, i) => (
                <div key={i} className="flex items-center">
                  <div className="flex flex-col items-center gap-1 sm:gap-2 px-4 sm:px-6 md:px-10 whitespace-nowrap">
                    <span className="font-bold text-[13px] sm:text-[15px] md:text-2xl text-[#0046A7] tracking-[0.07px]">
                      {item.value}
                    </span>
                    <span className="text-[11px] sm:text-[13px] md:text-sm text-[#6B7280]/80 tracking-[-0.15px]">
                      {item.label}
                    </span>
                  </div>
                  <span className="w-[1px] h-10 sm:h-12 md:h-16 bg-[#E0E0E0]"></span>
                </div>
              ))}
            </div>
          ))}
        </div>

        <style>{`
    @keyframes heroTicker {
      0%   { transform: translateX(0); }
      100% { transform: translateX(-25%); }
    }
  `}</style>
      </div>
    </>
  );
}
